// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b080dd2b","247":"94caea07","422":"dfb9df1a","627":"a6dbe7f8","768":"e17b6c48","834":"e8e8d6be","867":"4343475f","923":"0999725b","938":"0c8e5f97"}[chunkId] + ".chunk.js";
};